import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {KMDGameMode} from "../server/KMDGameMode";

export class KMDXHoleRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (KennethMustDie.model.xHPos === 1);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });

        tl.add([
            KennethMustDie.xHoleSuck.suckAction(),
            () => {
                controller.setSkipCallback(() => {
                    this.skip(tl);
                });
            }
        ]);

        // double up speed in SFS or entering SFS via SFS bonus buy
        if ((KennethMustDie.model.gameData.mode === KMDGameMode.FREESPIN_SUPER) || (KennethMustDie.sfsFeatureBought)) {
            tl.timeScale(2);
        }
    }

    private skip(tl: gsap.core.Timeline): void {
        tl.timeScale(4);
    }
}